var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 24,
    viewBox: "0 0 190 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2070",
    d: "M0 4.82729C0 3.73445 0.877208 2.84395 1.96993 2.82752L187.97 0.0305275C189.086 0.0137424 190 0.913969 190 2.0303V22C190 23.1046 189.105 24 188 24H2C0.895428 24 0 23.1046 0 22V4.82729Z",
    fill: "#97CC04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenRectangle);
export default __webpack_public_path__ + "static/media/green-rectangle.910687f393cbe56add5389733afd1f1c.svg";
export { ForwardRef as ReactComponent };